import { __assign, __rest } from "tslib";
import React, { Children, cloneElement, createRef, useEffect, forwardRef, } from 'react';
import { twMerge } from 'tailwind-merge';
var isAddonWithElement = function (childrenDisplayNames) {
    return (childrenDisplayNames.includes('InputLeftAddon') ||
        childrenDisplayNames.includes('InputRightAddon')) &&
        (childrenDisplayNames.includes('InputLeftElement') ||
            childrenDisplayNames.includes('InputRightElement'));
};
var createChildrenNodes = function (childrenStack, inputRef, inputLeftAddonRef, inputRightAddonRef, inputLeftElementRef, inputRightElementRef) {
    var children = [];
    var childrenDisplayNames = Object.keys(childrenStack);
    var isAdditionalWrapperNecessary = isAddonWithElement(childrenDisplayNames);
    if (childrenDisplayNames.includes('InputLeftAddon')) {
        children.push(cloneElement(childrenStack.InputLeftAddon, {
            ref: inputLeftAddonRef,
        }));
    }
    if (isAdditionalWrapperNecessary) {
        children.push(React.createElement("div", { key: "InputElementWrapper", className: "flex relative items-center w-full" },
            childrenDisplayNames.includes('InputLeftElement') &&
                cloneElement(childrenStack.InputLeftElement, {
                    ref: inputLeftElementRef,
                }),
            childrenStack.Input.ref
                ? cloneElement(childrenStack.Input)
                : cloneElement(childrenStack.Input, {
                    ref: inputRef,
                }),
            childrenDisplayNames.includes('InputRightElement') &&
                cloneElement(childrenStack.InputRightElement, {
                    ref: inputRightElementRef,
                })));
    }
    else {
        if (childrenDisplayNames.includes('InputLeftElement')) {
            children.push(cloneElement(childrenStack.InputLeftElement, {
                ref: inputLeftElementRef,
            }));
        }
        children.push(childrenStack.Input.ref
            ? cloneElement(childrenStack.Input)
            : cloneElement(childrenStack.Input, {
                ref: inputRef,
            }));
        if (childrenDisplayNames.includes('InputRightElement')) {
            children.push(cloneElement(childrenStack.InputRightElement, {
                ref: inputRightElementRef,
            }));
        }
    }
    if (childrenDisplayNames.includes('InputRightAddon')) {
        children.push(cloneElement(childrenStack.InputRightAddon, {
            ref: inputRightAddonRef,
        }));
    }
    return children;
};
export var InputContainer = forwardRef(function (_a, ref) {
    var children = _a.children, restProps = __rest(_a, ["children"]);
    var childrenStack = {};
    Children.toArray(children).forEach(function (child) {
        var name = child.displayName ||
            child.name ||
            (child.type || {}).displayName ||
            'Component';
        childrenStack[name] = child;
    });
    var inputLeftAddonRef = createRef();
    var inputRightAddonRef = createRef();
    var inputLeftElementRef = createRef();
    var inputRightElementRef = createRef();
    var inputRef = childrenStack.Input.ref || createRef();
    useEffect(function () {
        var _a, _b;
        var leftPadding = (_a = inputLeftElementRef === null || inputLeftElementRef === void 0 ? void 0 : inputLeftElementRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth;
        var rightPadding = (_b = inputRightElementRef === null || inputRightElementRef === void 0 ? void 0 : inputRightElementRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth;
        var leftAddonExists = inputLeftAddonRef.current;
        var rightAddonExists = inputRightAddonRef.current;
        var input = inputRef.current;
        if (input) {
            input.style.paddingLeft = leftPadding
                ? "".concat(leftPadding + 14, "px")
                : '';
            input.style.paddingRight = rightPadding
                ? "".concat(rightPadding + 14, "px")
                : '';
            if (leftAddonExists) {
                input.style.borderBottomLeftRadius = '0';
                input.style.borderTopLeftRadius = '0';
                input.style.borderLeft = 'none';
            }
            if (rightAddonExists) {
                input.style.borderBottomRightRadius = '0';
                input.style.borderTopRightRadius = '0';
                input.style.borderRight = 'none';
            }
        }
    }, [
        inputLeftAddonRef,
        inputRightAddonRef,
        inputRightElementRef,
        inputRef,
        inputLeftElementRef,
    ]);
    return (React.createElement("div", __assign({}, restProps, { ref: ref, className: twMerge('relative flex items-center w-full', restProps.className) }), createChildrenNodes(childrenStack, inputRef, inputLeftAddonRef, inputRightAddonRef, inputLeftElementRef, inputRightElementRef)));
});
